import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.667 13.333H3.333a.667.667 0 1 0 0 1.334h9.334a.667.667 0 0 0 0-1.334m-5.14-1.526q.096.091.22.14a.63.63 0 0 0 .506 0 .7.7 0 0 0 .22-.14L11.14 9.14a.67.67 0 0 0-.947-.947L8.667 9.727V2a.667.667 0 0 0-1.334 0v7.727L5.807 8.193a.67.67 0 0 0-.947.947z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })